import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { CacheService, ITypeUserVisibilityRuleBO, ITypeVisibilityRuleBO } from '@mapfre-tech/amap3';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: "root"
})
export class VisibilityService {

  className = 'VisibilityService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllVisibilityRules(cache = true, cacheKey = "allVisibilityRules"): Observable<ITypeVisibilityRuleBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeVisibilityRuleBO[]>;
    } else {
      const observable = this.http.get<ITypeVisibilityRuleBO[]>(environment.base_URL + "/visibility-rule-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newVisibilityRule(rule: ITypeVisibilityRuleBO) {
    return this.http.post(environment.base_URL + "/visibility-rule-types", rule)
  }

  updateVisibilityRule(rule: ITypeVisibilityRuleBO, id: number) {
    return this.http.put(environment.base_URL + `/visibility-rule-types/${id}`, rule)
  }

  deleteVisibilityRule(id: number) {
    return this.http.delete(environment.base_URL + `/visibility-rule-types/${id}`)
  }

  getAllUserVisibility(cache = true, cacheKey = "allUserVisibility"): Observable<ITypeUserVisibilityRuleBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeUserVisibilityRuleBO[]>;
    } else {
      const observable = this.http.get<ITypeUserVisibilityRuleBO[]>(environment.base_URL + "/user-visibility-rule-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newVisibilityUser(rule: ITypeUserVisibilityRuleBO[], userId: number) {
    return this.http.post(environment.base_URL + `/user-visibility-rule-types?userId=${userId}`, rule)
  }

  updateVisibilityUser(rule: ITypeUserVisibilityRuleBO, id: number) {
    return this.http.put(environment.base_URL + `/user-visibility-rule-types/${id}`, rule)
  }

  deleteVisibilityUser(id: number) {
    return this.http.delete(environment.base_URL + `/user-visibility-rule-types/${id}`)
  }
}
